import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-holistic-view-of-personal-finance",
    component: _cffe3db6,
    name: "a-holistic-view-of-personal-finance"
  }, {
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/coming-to-grips-with-risk",
    component: _cffe3db6,
    name: "coming-to-grips-with-risk"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/digging-out-of-debt",
    component: _cffe3db6,
    name: "digging-out-of-debt"
  }, {
    path: "/do-you-need-a-financial-planner",
    component: _cffe3db6,
    name: "do-you-need-a-financial-planner"
  }, {
    path: "/financial-literacy-in-healthcare",
    component: _cffe3db6,
    name: "financial-literacy-in-healthcare"
  }, {
    path: "/financial-planning-during-covid-19",
    component: _cffe3db6,
    name: "financial-planning-during-covid-19"
  }, {
    path: "/financial-resolutions-for-2022",
    component: _cffe3db6,
    name: "financial-resolutions-for-2022"
  }, {
    path: "/financing-and-paying-off-your-medical-education",
    component: _cffe3db6,
    name: "financing-and-paying-off-your-medical-education"
  }, {
    path: "/funding-the-realistic-fairy-tale-wedding",
    component: _cffe3db6,
    name: "funding-the-realistic-fairy-tale-wedding"
  }, {
    path: "/how-to-pay-off-your-medical-debt",
    component: _cffe3db6,
    name: "how-to-pay-off-your-medical-debt"
  }, {
    path: "/lets-talk-about-taxes",
    component: _cffe3db6,
    name: "lets-talk-about-taxes"
  }, {
    path: "/maintaining-good-credit-and-what-to-avoid",
    component: _cffe3db6,
    name: "maintaining-good-credit-and-what-to-avoid"
  }, {
    path: "/making-personal-finance-easier",
    component: _cffe3db6,
    name: "making-personal-finance-easier"
  }, {
    path: "/our-blog",
    component: _cffe3db6,
    name: "our-blog"
  }, {
    path: "/so-you-want-to-pay-for-college",
    component: _cffe3db6,
    name: "so-you-want-to-pay-for-college"
  }, {
    path: "/sorting-wants-from-needs",
    component: _cffe3db6,
    name: "sorting-wants-from-needs"
  }, {
    path: "/the-fire-movement---is-it-for-you",
    component: _cffe3db6,
    name: "the-fire-movement---is-it-for-you"
  }, {
    path: "/the-great-resignation-and-how-to-responsibly-change-careers",
    component: _cffe3db6,
    name: "the-great-resignation-and-how-to-responsibly-change-careers"
  }, {
    path: "/the-psychology-of-finances",
    component: _cffe3db6,
    name: "the-psychology-of-finances"
  }, {
    path: "/the-strategic-retirement-planning-roadmap",
    component: _cffe3db6,
    name: "the-strategic-retirement-planning-roadmap"
  }, {
    path: "/client-resources/calculators",
    component: _cffe3db6,
    name: "calculators"
  }, {
    path: "/get-in-touch/location-and-contact",
    component: _cffe3db6,
    name: "location-and-contact"
  }, {
    path: "/how-we-do-it/partnering-with-professionals",
    component: _cffe3db6,
    name: "partnering-with-professionals"
  }, {
    path: "/how-we-do-it/three-ways-to-engage",
    component: _cffe3db6,
    name: "three-ways-to-engage"
  }, {
    path: "/what-we-do/for-business-owners",
    component: _cffe3db6,
    name: "for-business-owners"
  }, {
    path: "/what-we-do/for-healthcare-professionals",
    component: _cffe3db6,
    name: "for-healthcare-professionals"
  }, {
    path: "/who-we-are/our-alliances",
    component: _cffe3db6,
    name: "our-alliances"
  }, {
    path: "/who-we-are/our-beliefs",
    component: _cffe3db6,
    name: "our-beliefs"
  }, {
    path: "/who-we-are/our-team",
    component: _cffe3db6,
    name: "our-team"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "willeke-financial-group-llc-lincoln-ne"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
